import { Component, NgZone } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { NavController, ModalController, NavParams} from 'ionic-angular';

import { UserData } from '../../providers/user-data';

import moment from 'moment';

import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { UEModel } from '../ue/ue-model';
import { PPListPage } from '../pp-list/pp-list';
import { KontrollenData } from '../kontrollen/kontrollen-data';
import { Platform } from 'ionic-angular';

declare var CordovaExif : any;
declare var cordova : any;
declare var FileTransfer : any;
declare var HTMLImageElement : any;
declare var navigator : any;
declare var device : any;

@Component({
  selector: 'ue-upload',
  templateUrl: 'ue-upload.html'
})
export class UEUploadPage {
  sNormalColor = "primary";
  sCheckedColor = "favorite";

  bUEUploaded : boolean = false;
  bFoto1Uploaded : boolean = false;
  bFoto2Uploaded : boolean = false;
  bFoto3Uploaded : boolean = false;
  bUploadedFinished : boolean = false;
  grundid:number;
  fkkontrolle:number;

  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public kontrollenData: KontrollenData
            , public toastCtrl: ToastController
            , public zone: NgZone
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public ueModel: UEModel 
            , public platform:Platform
            ) {
    //let selectedpp = navParams.get('pp');
    
    //console.log("uedata param");
    this.grundid = navParams.data.grundid;
    this.fkkontrolle = navParams.data.fkkontrolle;
    //console.log(this.grundid);
    //console.log(this.fkkontrolle);
    //console.log("uedata local");
    //console.log(ueModel.iGrundid);
    //console.log(ueModel.fkkontrolle);
    this.init();
    //console.log('Grundid:'+this.ueModel.iGrundid);
    this.uploadUE();
   }

   init(){
  
   }

   public onFinishUpload(){
     console.log("on finish upload");

    this.navCtrl.pop();
    //this.navCtrl.setRoot(PPListPage);  
   }

  public uploadUE() {
      var link = this.common.baseurl+'bussen/erfassen';
      //console.log("1");
      console.log(this.ueModel);

      var data = JSON.stringify({
            datum: this.ueModel.sDateTimeAuto
          , datum2: this.ueModel.sDateTimeAuto2
          , datum3: this.ueModel.sDateTimeBeweis
          , fkuser: this.userData.userid
          , user: this.userData.email
          , urlident: this.ueModel.sQRCode
          , grundstueck: this.grundid
          , token: this.userData.jwt
          , fkkontrolle: this.fkkontrolle
          , autonummer: this.ueModel.autonummer
          , kontrollkommentar: this.ueModel.kontrollkommentar
          , checkresultdata: this.ueModel.checkresultdata
        });
        //console.log(data);
        //console.log("2");
      
      this.http.post(link, data)
      .subscribe(data => {
        let aResponse = data.json();
        if(aResponse.success === true){
          if(aResponse.data.busid > 0){
            if(this.common.staging != "" && !this.platform.is('cordova')){
              this.zone.run(() => {
                this.ueModel.clear();
                this.bUploadedFinished = true;
                this.navCtrl.pop();
              });
              return;
            }
            this.zone.run(() => { 
              this.bUEUploaded = true;        
            });

            var fileTransfer = new FileTransfer();
            var randomstring = this.common.random(10);
            //-- Upload Foto Auto -------
            let options = {
                fileKey: "file",
                fileName: aResponse.data.busid+"_"+randomstring+"_1.jpg",
                chunkedMode: false,
                mimeType: "image/jpeg",
                params:{
                  datum: this.ueModel.sDateTimeAuto,
                  busid: aResponse.data.busid,
                  descr: 'Foto Auto',
                  fileno: 1
                }
            };
            this.ueModel.iUploadCounter++;          
            
            fileTransfer.upload(this.ueModel.srcPhotoAuto,encodeURI(this.common.portalurl+"fileuploadue.php"),this.onSuccessFileupload.bind(this), this.onFailFileupload.bind(this),options);
          
            //-- Upload Foto Auto2 -------
            if(this.ueModel.srcPhotoAuto2){
              this.ueModel.iUploadCounter++;
              options.fileName = aResponse.data.busid+"_"+randomstring+"_2.jpg";
              options.params.datum = this.ueModel.sDateTimeAuto2;
              options.params.descr = 'Foto Reserve';
              options.params.fileno = 2;
              fileTransfer.upload(this.ueModel.srcPhotoAuto2,encodeURI(this.common.portalurl+"fileuploadue.php"),this.onSuccessFileupload.bind(this), this.onFailFileupload.bind(this),options);
            }
            //-- Upload Foto Beweis -------
            if(this.ueModel.srcPhotoBeweis){
              this.ueModel.iUploadCounter++;
              options.fileName = aResponse.data.busid+"_"+randomstring+"_3.jpg";
              options.params.datum = this.ueModel.sDateTimeBeweis;
              options.params.descr = 'Foto Beweis';
              options.params.fileno = 3;          
              fileTransfer.upload(this.ueModel.srcPhotoBeweis,encodeURI(this.common.portalurl+"fileuploadue.php"),this.onSuccessFileupload.bind(this), this.onFailFileupload.bind(this),options);
            }
          }
          else{
            //TODO Fehler, UE konnte nicht erzeug werden
            let toast = this.toastCtrl.create({
              message: 'UE-Id fehlerhaft',
              dismissOnPageChange: true,
              duration: 5000,
              position: 'middle',
              cssClass: 'warning',
              closeButtonText: 'schliessen',
              showCloseButton: true
            });
            toast.present();        
            this.navCtrl.pop();         
          }
        }
        else{
          //response.success ist false
          let toast = this.toastCtrl.create({
            message: aResponse.message,
            dismissOnPageChange: true,
            duration: 5000,
            position: 'middle',
            cssClass: 'warning',
            closeButtonText: 'schliessen',
            showCloseButton: true
          });
          toast.present();     
          this.navCtrl.pop();       
        }

        
      }, error => {
          console.log(error);
          let toast = this.toastCtrl.create({
            message: "Fehler beim erzeugen der UE",
            dismissOnPageChange: true,
            duration: 5000,
            position: 'middle',
            cssClass: 'warning',
            closeButtonText: 'schliessen',
            showCloseButton: true
          });
          toast.present();              
          console.log("Fehler beim erzeugen der UE");//TODO Toast
          this.navCtrl.pop(); 
      });
  }//ueUpload

  private onSuccessFileupload(result){
      //result = JSON.parse(result);
      let response = JSON.parse(result.response);
      //console.log(response.fileno);
      if(response.success === true){
        console.log('upload success');

        if(response.fileno==1){
          this.zone.run(() => {   
            this.bFoto1Uploaded = true;
          });
        }
        else if(response.fileno==2){
          this.zone.run(() => {   
            this.bFoto2Uploaded = true;
          });
        }
        else if(response.fileno==3){
          this.zone.run(() => {   
            this.bFoto3Uploaded = true;
          });
        }
        this.ueModel.iUploadCounter--;
        if(this.ueModel.iUploadCounter == 0){
          this.zone.run(() => {
            this.ueModel.clear();
            this.bUploadedFinished = !this.bUploadedFinished;
          });
        }
      }
      else{
          let toast = this.toastCtrl.create({
            message: 'Fehler:'+response.message,
            dismissOnPageChange: true,
            duration: 5000,
            position: 'middle',
            cssClass: 'warning',
            closeButtonText: 'schliessen',
            showCloseButton: true
          });
          toast.present();      
      }
      
  }


  private onFailFileupload(err){
      let toast = this.toastCtrl.create({
        message: 'Fehler beim Upload',
        dismissOnPageChange: true,
        duration: 5000,
        position: 'middle',
        cssClass: 'warning',
        closeButtonText: 'schliessen',
        showCloseButton: true
      });
      toast.present();  
      this.navCtrl.pop(); 
  }  

  
}



// WEBPACK FOOTER //
// ./src/pages/ue/ue-upload.ts